import Http from '@/Http';
import { Product } from '@/types/work/product';
import { GET_ENTERPRISE } from '@/store/models/work/enterprises';
import { Enterprise } from '@/types/work/enterprise';
import objectToFormData from '@/modules/ObjectToFormData';

const PATH = 'work/enterprises/products/';
export const PRODUCTS_REQUEST = PATH + 'request';
export const PRODUCT_REQUEST = PATH + 'showRequest';
export const STORE_REQUEST = PATH + 'storeRequest';
export const GET_PRODUCTS = PATH + 'getProducts';
export const GET_PRODUCT = PATH + 'getProduct';
export const GET_STATUS = PATH + 'getStatus';

const state = {
  status: null,
  products: [],
  product: {}
};

const getters = {
  getProducts: (state:any):Array<Product> => state.products,
  getProduct: (state:any):Array<Product> => state.product,
  getStatus: (state:any):Array<Product> => state.status
};

const actions = {
  request: ({ commit, rootGetters }:any, filter:any = {}) => {
    filter = {
      'filters[order_by]': 'title',
      ...filter
    };
    let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
    commit('request');
    (new Http()).request({ url: `enterprise/${enterprise.id}/products`, params: filter })
      .then((resp:any) => {
        commit('success', resp.data.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  showRequest: ({ commit, rootGetters }:any, id: number) => {
    commit('request');
    let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
    (new Http()).request({ url: `enterprise/${enterprise}/products/${id}` })
      .then((resp:any) => {
        commit('success', resp.data.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  storeRequest: ({ commit, rootGetters }:any, data:Product) => {
    let validData:any = {
      title: data.title,
      category_id: data.category_id,
      type_category_id: data.type_category_id,
      price: data.price,
      opt_price: data.opt_price,
      big_opt_price: data.big_opt_price,
      wholesale_price: data.wholesale_price,
      article: data.article,
      measure_id: data.measure_id,
      min_value: data.min_value,
      max_value: data.max_value,
      color: data.color,
      photos: data.photos,
      in_bookmarks: data.in_bookmarks
    };
    commit('request');
    return new Promise((resolve, reject) => {
      let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
      let url = data.id
        ? `enterprise/${enterprise.id}/products/${data.id}`
        : `enterprise/${enterprise.id}/products`;
      (new Http()).request({ url: url, data: objectToFormData.transform(validData), method: 'POST' })
        .then((resp:any) => {
          if (resp.data.data) {
            commit('successStore', { resp: data, update: !!data.id });
          }
          resolve(resp.data.data);
        })
        .catch((e:any) => {
          commit('error');
          reject(e);
        });
    });
  }
};

const mutations = {
  request: (state:any) => {
    state.status = null;
  },
  success: (state:any, resp:Array<Product>) => {
    state.status = true;
    state.products = resp;
  },
  successStore: (state:any, { resp, update }:any) => {
    state.status = true;
    if (update) {
      let found = false;
      for (let i = 0; i < state.products.length; i++) {
        if (state.products[i].id === resp.id) {
          state.products[i] = resp;
          found = true;
          break;
        }
      }
      if (!found) {
        state.products[state.products.length] = resp;
      }
    } else {
      state.products[state.products.length] = resp;
    }
  },
  error: (state:any) => {
    state.status = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
